























































































































































import Vue from "vue";
import Component from "vue-class-component";
import {
  FactFindLiabilityLoanDto,
  CreateLiabilityLoanCommand,
  OwnerDto,
  YesNoDefaultDto,
  ProductProviderDto,
  UpdateLiabilityLoanCommand,
  ClientSelector
} from "@/api/ClientPortalApiClient";
import ApiFactory from "../../api/ApiFactory";
import CbxOwner from "@/views/lookups/CbxOwner.vue";
import CbxYesNoDefault from "@/views/lookups/CbxYesNoDefault.vue";
import CbxProductProvider from "@/views/lookups/CbxProductProvider.vue";
import AlertService from "../../services/alert.service";
import { LoadingSpinnerService } from "@/store";
import { FormatDate } from "../../filters/FormatDate";

@Component({
  components: {
    CbxOwner,
    CbxYesNoDefault,
    CbxProductProvider
  }
})
export default class FactFindLiabilityLoan extends Vue {
  private alertService = new AlertService();
  private contactId: number = 0;
  private loans: FactFindLiabilityLoanDto[] = [];
  private emptyLoan = new FactFindLiabilityLoanDto();
  private selectLoan = new FactFindLiabilityLoanDto();
  private displayModel = new FactFindLiabilityLoanDto();
  private formEnabled: boolean = false;
  private mode: string = "default";
  private clientNames: OwnerDto[] = [];
  private modelSig = "";

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
    await this.loadLoans(true);
    await this.getClientSelectorNames();
  }

  private async getClientSelectorNames() {
    const api = ApiFactory.CreateDataClient();
    const data = await api.owner_Index(this.contactId);
    this.clientNames = data || [];
  }

  private loanDisplayName(loan: FactFindLiabilityLoanDto): string {
    const owner = this.clientNames.find(x => x.id === loan.owner);
    return (
      (owner ? owner.name : "") + " - " + (loan.lender ? loan.lender.name : "")
    );
  }

  $refs!: {
    owner: CbxOwner;
    lender: CbxProductProvider;
    mainForm: HTMLFormElement;
  };

  private saveLoan(e: Event) {
    e.preventDefault();
    if (this.mode === "update") {
      this.update();
    } else if (this.mode === "create") {
      this.createNew();
    }
  }

  private async createNew(): Promise<boolean> {
    LoadingSpinnerService.Show("Saving new Loan...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new CreateLiabilityLoanCommand();

    cmd.contactId = this.contactId;
    cmd.owner = this.displayModel.owner;
    cmd.termInYears = this.displayModel.termInYears;
    cmd.amountBorrowed = this.displayModel.amountBorrowed;
    cmd.currentBalance = this.displayModel.currentBalance;
    cmd.monthlyRepayment = this.displayModel.monthlyRepayment;
    cmd.annualPercentageRate = this.displayModel.annualPercentageRate;

    cmd.dateStarted = FormatDate.forApi(this.displayModel.dateStarted);

    if (this.displayModel.lender) {
      cmd.lenderId = this.displayModel.lender.id;
    }
    try {
      const result = await api.factFindLiabilityLoan_IndexPOST(cmd);
      this.displayModel.id = result;
      await this.loadLoans();
      this.displayModel =
        this.loans.find(x => x.id === result) || this.displayModel;
      this.mode = "update";
      this.modelSig = this.displayModel.toJSON();
      LoadingSpinnerService.Success("Loan saved successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save Loan. Please try again.");
    }

    return false;
  }

  private async update(): Promise<boolean> {
    LoadingSpinnerService.Show("Updating Loan...");
    const api = ApiFactory.CreateDataClient();
    let cmd = new UpdateLiabilityLoanCommand();

    cmd.contactId = this.contactId;
    cmd.id = this.displayModel.id;
    cmd.owner = this.displayModel.owner;
    cmd.termInYears = this.displayModel.termInYears;
    cmd.amountBorrowed = this.displayModel.amountBorrowed;
    cmd.currentBalance = this.displayModel.currentBalance;
    cmd.monthlyRepayment = this.displayModel.monthlyRepayment;
    cmd.annualPercentageRate = this.displayModel.annualPercentageRate;
    cmd.dateStarted = FormatDate.forApi(this.displayModel.dateStarted);

    if (this.displayModel.lender) {
      cmd.lenderId = this.displayModel.lender.id;
    }

    try {
      await api.factFindLiabilityLoan_IndexPUT(cmd);
      this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();
      LoadingSpinnerService.Success("Loan updated successfully");
      return true;
    } catch (e) {
      LoadingSpinnerService.Failure("Could not save Loan. Please try again.");
    }

    return false;
  }

  private async loadLoans(showLoader: boolean | undefined = undefined) {
    if (showLoader) LoadingSpinnerService.Show("Loading Loans...");
    const api = ApiFactory.CreateDataClient();

    try {
      const result = await api.factFindLiabilityLoan_IndexAll(this.contactId);
      this.loans = result || [];
      if (showLoader) LoadingSpinnerService.Hide();
    } catch (e) {
      this.loans = [];
      LoadingSpinnerService.Failure("Could not load Loans. Please try again.");
    }
  }

  private async rowSelected(item: FactFindLiabilityLoanDto) {
    if (!(await this.checkForChanges())) {
      return;
    }

    this.clearData();
    this.formEnabled = true;
    this.mode = "update";
    this.displayModel = item;
    this.displayModel.dateStarted = FormatDate.forInput(item.dateStarted);
    this.modelSig = JSON.stringify(this.displayModel.toJSON()).toString();

    if (this.displayModel.owner) {
      this.$refs.owner.setSelected(this.displayModel.owner);
    } else {
      this.$refs.owner.setSelected(ClientSelector.Main);
    }

    this.$refs.lender.setSelected(this.displayModel.lender);
  }

  private saveClicked() {
    this.formEnabled = false;
    this.clearData();
    this.mode = "default";
  }

  private createClicked() {
    this.clearData();
    this.mode = "create";
    this.formEnabled = true;
  }

  private updateClicked() {
    this.mode = "update";
    this.formEnabled = true;
  }

  private clearData() {
    this.displayModel = this.emptyLoan;
    this.displayModel.owner = ClientSelector.Main;
    this.$refs.owner.setSelected(ClientSelector.Main);
    this.$refs.lender.setSelected(new ProductProviderDto());
  }

  public async checkForChanges(): Promise<boolean> {
    if (this.isDisplayModelEmpty() == false) {
      if (this.hasChanges() == true) {
        if (confirm("Would you like to save your changes?")) {
          return await this.saveChanges();
        }
      }
    }

    return true;
  }

  public async saveChanges(): Promise<boolean> {
    if (this.$refs.mainForm.checkValidity()) {
      if (this.mode === "update") {
        return await this.update();
      } else if (this.mode === "create") {
        return await this.createNew();
      }

      return true;
    }

    this.alertService.error(
      "Form Validation Failed",
      "Please complete all required fields"
    );
    return false;
  }

  private isDisplayModelEmpty(): boolean {
    return (
      this.mode !== "create" &&
      JSON.stringify(this.displayModel.toJSON()) ===
        JSON.stringify(this.emptyLoan.toJSON())
    );
  }

  private hasChanges(): boolean {
    const s1 = JSON.stringify(this.displayModel.toJSON()).toString();
    if (s1 !== this.modelSig) {
      return true;
    } else {
      return false;
    }
  }

  private ownerSelected(owner: ClientSelector) {
    this.displayModel.owner = owner;
  }
  private productProviderSelected(lender: ProductProviderDto) {
    this.displayModel.lender = lender;
  }
}
